var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSystemsBackend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.941 66.8456C150.641 66.727 175.031 91.139 175 120.941C174.969 150.733 150.894 174.866 121.065 175C91.3954 175.134 66.9646 150.686 67.0007 120.905C67.0367 91.1081 91.1276 66.9643 120.936 66.8456H120.941ZM131.959 98.3445C130.367 98.4374 128.698 99.3503 127.879 101.362C127.004 103.502 127.308 105.545 128.992 107.237C133.175 111.445 137.342 115.67 141.591 119.811C142.554 120.75 142.415 121.219 141.545 122.076C137.388 126.156 133.283 130.287 129.183 134.429C126.957 136.677 126.849 139.963 128.884 142.026C130.949 144.12 134.184 144.079 136.461 141.82C142.142 136.182 147.803 130.524 153.428 124.835C155.787 122.447 155.772 119.394 153.402 116.995C147.772 111.306 142.101 105.663 136.44 100.005C135.353 98.917 134.066 98.3084 131.964 98.3497L131.959 98.3445ZM114.508 138.431C114.58 136.791 113.874 135.502 112.741 134.372C108.692 130.333 104.711 126.233 100.585 122.272C99.3948 121.127 99.5596 120.575 100.641 119.523C104.711 115.582 108.677 111.543 112.669 107.525C115.002 105.179 115.141 101.929 113.04 99.8145C110.933 97.6946 107.683 97.8184 105.339 100.16C99.7502 105.736 94.1718 111.322 88.6088 116.923C86.1157 119.435 86.1518 122.432 88.6706 124.98C90.5816 126.919 92.5132 128.838 94.4396 130.761C98.1689 134.501 101.888 138.251 105.643 141.964C107.271 143.574 109.223 143.96 111.35 143.14C113.297 142.387 114.492 140.536 114.508 138.426V138.431Z",
    fill: "url(#paint0_linear_25_501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5667 63.3897C69.3288 63.2659 56.1888 62.2756 43.3527 58.7735C38.6705 57.4943 34.1274 55.8335 30.2076 52.8626C26.9161 50.3714 24.7218 47.2767 25.3245 42.8461C25.6902 40.1589 27.1737 38.1164 29.1413 36.3988C32.8345 33.1803 37.2849 31.4473 41.8795 30.0495C49.7605 27.6563 57.868 26.5267 66.0477 25.7634C74.0316 25.0155 82.0207 24.8195 90.0098 25.165C102.408 25.7015 114.719 26.9136 126.54 31.0553C129.677 32.1539 132.665 33.5775 135.322 35.62C141.782 40.5818 141.874 47.5346 135.492 52.6202C131.547 55.7613 126.885 57.4221 122.11 58.7683C114.24 60.981 106.184 62.09 98.0452 62.745C92.8891 63.1576 87.7382 63.4413 82.5615 63.3949L82.5667 63.3897Z",
    fill: "url(#paint1_linear_25_501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9213 73.7468C73.8513 76.8054 71.2089 79.7557 68.8755 82.9793C65.2235 88.034 62.3184 93.4858 60.2786 99.3915C59.9953 100.217 59.7893 100.8 58.651 100.686C48.9621 99.7216 39.335 98.4528 30.1149 95.126C25.0618 93.3053 25.0824 93.2434 25.0824 87.9824C25.0824 80.029 25.0824 72.0705 25.0824 64.1171C25.0824 63.5291 25.0824 62.9463 25.0824 62.1675C41.143 71.5289 58.8055 72.8803 76.9161 73.7468H76.9213Z",
    fill: "url(#paint2_linear_25_501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4377 145.822C55.3802 145.12 49.6111 144.171 43.9451 142.624C39.7935 141.489 35.75 140.086 32.0362 137.869C27.4055 135.104 24.7631 131.339 25.0155 125.588C25.3039 118.955 25.1082 112.296 25.0618 105.653C25.0515 104.425 25.273 104.183 26.4783 104.657C34.2717 107.716 42.4668 109.057 50.7083 110.15C52.5935 110.403 54.4839 110.63 56.3743 110.795C57.2397 110.872 57.2757 111.264 57.1778 111.981C55.9159 121.281 56.5546 130.441 59.2794 139.431C59.9078 141.505 60.6599 143.542 61.4325 145.822H61.4377Z",
    fill: "url(#paint3_linear_25_501)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25_501",
    x1: 121,
    y1: 66.8452,
    x2: 121,
    y2: 175.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_25_501",
    x1: 82.7241,
    y1: 25,
    x2: 82.7241,
    y2: 63.3998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_25_501",
    x1: 51.0018,
    y1: 62.1675,
    x2: 51.0018,
    y2: 100.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_25_501",
    x1: 43.2183,
    y1: 104.431,
    x2: 43.2183,
    y2: 145.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(25 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemsBackend);
export default __webpack_public_path__ + "static/media/Systems_&_Backend.f2030d89f2890f806a759e07818a60e4.svg";
export { ForwardRef as ReactComponent };